/** @format */

import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useAuth } from "../contexts/AuthContext";

const AdminPanel: React.FC = () => {
  const { currentUser } = useAuth();
  const normalizedRole = (currentUser?.role || '').toString().trim().toLowerCase();
  // Allow access for admin users and approved authors (not pending authors)
  const isAuthorized = normalizedRole === "admin" || (normalizedRole === "author" && currentUser?.status !== "pending");
  const navigate = useNavigate();

  if (!isAuthorized) {
    return <Navigate to="/app" replace />;
  }

  return (
    <div className="fixed inset-0 z-[11000] w-screen h-screen bg-black">
      <button
        onClick={() => navigate("/app")}
        aria-label="Close Admin Panel"
        title="Close"
        className="absolute top-4 right-4 z-[11010] inline-flex items-center justify-center rounded-full bg-white/90 hover:bg-white shadow-lg p-2 text-gray-700 hover:text-gray-900"
      >
        <XMarkIcon className="h-6 w-6" />
      </button>
      <iframe
        src="https://profstudymateadmin.com/"
        title="Admin Panel"
        className="w-full h-full border-0"
        allow="clipboard-write; fullscreen;"
        allowFullScreen
      />
    </div>
  );
};

export default AdminPanel;


